import { Navigate } from 'react-router-dom';
import Main from '../components/layout/Main';
import { isAuthenticatedSession } from "../services/ginjaAuth";
export const PrivateRoute = ({ children }) => {
  return isAuthenticatedSession() ? <Main>{children}</Main> : <Navigate to="/login" replace />;
};
